import { api } from "../api/api"

export async function asyncForEach(array: Array<any>, callback: Function) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}

export const requestGetClient = (json: any) => {
    return api.requestGetClient(json)
}

export const requestGetClientAnonym = (json: any) => {
    return api.requestGetClientAnonym(json)
}